// Uncaught errors and unhandled promise rejections, as ERROR lines from
// origin "window" in the Console's Logs tab.
//
// They go to the Logs tab only. The browser has already printed them in
// DevTools, so mirroring would show each one twice. The routing lives in
// configureLogging (the ['orovia', 'window'] logger overrides its parent's
// sinks with just the widget).
import { getLog, GLOBAL_ERROR_ORIGIN } from './logger'

export { GLOBAL_ERROR_ORIGIN }

function describe(value: unknown): string {
  if (value instanceof Error) return value.message || value.name
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value) ?? String(value)
  } catch {
    return String(value)
  }
}

export function installGlobalErrorCapture(target: Window = window): () => void {
  const log = getLog(GLOBAL_ERROR_ORIGIN)

  const onError = (event: ErrorEvent) => {
    const where = event.filename ? ` (${event.filename}:${event.lineno}:${event.colno})` : ''
    const text = `Uncaught: ${event.error != null ? describe(event.error) : event.message}${where}`
    if (event.error instanceof Error) log.error(text, event.error)
    else log.error(text)
  }

  const onRejection = (event: PromiseRejectionEvent) => {
    const reason: unknown = event.reason
    const text = `Unhandled rejection: ${describe(reason)}`
    if (reason instanceof Error) log.error(text, reason)
    else log.error(text)
  }

  target.addEventListener('error', onError)
  target.addEventListener('unhandledrejection', onRejection)
  return () => {
    target.removeEventListener('error', onError)
    target.removeEventListener('unhandledrejection', onRejection)
  }
}
